import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import TranslatedText from "./TranslatedText";
import backgroundImage from "../assets/images/corporative.png";
import backgroundImage2 from "../assets/images/letter.png";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function OutlinedCard() {
  return (
    <>
      <Card
        sx={{
          border: "none",
          boxShadow: "none",
          minWidth: "27vw",
          minHeight: "100vh",
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          "@media screen and (max-width: 1024px)": {
            backgroundImage: `url(${backgroundImage})`,
            marginTop: "0",
            minHeight: "50vh",
          },
          "@media screen and (max-width: 690px)": {
            backgroundImage: `url(${backgroundImage2})`,
            marginTop: "8vh",
            backgroundColor: "#04254a",
          },
        }}
      >
        <CardContent>
          <Typography
            variant="h1"
            sx={{
              fontSize: 36,
              fontWeight: 100,
              paddingButton: 9,
              marginTop: "13vh",
              textAlign: "center",
              "@media screen and (max-width: 1024px)": {
                fontSize: "28px",
                marginTop: "6vh",
              },
              "@media screen and (max-width: 690px)": {
                fontSize: "30px",
                paddingTop: "7vh",
              },
            }}
            gutterBottom
          >
            <TranslatedText defaultText="Інформаційна підтримка українських біженців" />
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontSize: 36,
              fontWeight: 100,
              paddingButton: 9,
              marginTop: "2vh",
              textAlign: "center",
              "@media screen and (max-width: 1024px)": {
                fontSize: "28px",
                marginTop: "0",
              },
              "@media screen and (max-width: 690px)": {
                display: "none",
              },
            }}
            gutterBottom
          >
            <TranslatedText defaultText="Заняття для дітей та дорослих" />
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}
